"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
const StickyBox_1 = __importDefault(require("@web/common/StickyBox"));
(() => {
    document.addEventListener('ReactListingOffersListLoadedEvent', () => {
        const subscriptionListingFilters = document.querySelector('.subscription-listing-filters');
        const gridFlexContainer = document.querySelector('.grid-flex');
        let filterMobileButtonContainer;
        let filterMobileButton;
        function createFiltersStickyBox() {
            if (subscriptionListingFilters === null || gridFlexContainer === null) {
                return;
            }
            (() => new StickyBox_1.default(subscriptionListingFilters, gridFlexContainer))();
        }
        function getMobileButtons() {
            filterMobileButtonContainer = document.querySelector('.filter-button-container');
            filterMobileButton = document.querySelector('#show-filter-mobile-button-container');
        }
        function handleResize() {
            window.addEventListener('resize', () => {
                getMobileButtons();
            });
        }
        function handleScroll() {
            window.addEventListener('scroll', () => {
                if (filterMobileButtonContainer === null || filterMobileButton === null) {
                    return;
                }
                const scrollTop = window.scrollY;
                const topOffset = filterMobileButtonContainer.getBoundingClientRect().top + scrollTop;
                if (ScreenSize_1.default.isSmallScreen() && scrollTop >= topOffset) {
                    filterMobileButton.classList.add('fixed');
                }
                else {
                    filterMobileButton.classList.remove('fixed');
                }
            });
        }
        getMobileButtons();
        createFiltersStickyBox();
        handleScroll();
        handleResize();
    });
})();
